import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Zap, Wifi } from 'lucide-react';
export function HardwareSlide() {
  const features = [{
    icon: <Zap className="w-6 h-6 text-yellow-400" data-id="element-30" />,
    title: 'Direct Meter Connection',
    desc: 'Connects directly to the digital energy meter for real-time data.'
  }, {
    icon: <div className="w-6 h-6 text-blue-400" data-id="element-31" />,
    title: 'Universal Compatibility',
    desc: 'One device for all charger OEMs. Streamlines technician education.'
  }, {
    icon: <Wifi className="w-6 h-6 text-green-400" data-id="element-32" />,
    title: 'Cloud Optimization',
    desc: 'Enables load balancing and energy optimization via the cloud.'
  }, {
    icon: <Cpu className="w-6 h-6 text-purple-400" data-id="element-33" />,
    title: 'Simplified Install',
    desc: 'Eliminates need for extra cabling and OEM-specific energy meters.'
  }];
  return <div className="h-full w-full flex flex-col md:flex-row items-center justify-center px-8 md:px-16 bg-slate-950 gap-12" data-id="element-34">
      <div className="flex-1 max-w-xl" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-36">
          <div className="inline-flex items-center justify-center p-3 bg-blue-500/10 rounded-xl mb-6" data-id="element-37">
            <Cpu className="w-10 h-10 text-blue-500" data-id="element-38" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-39">
            Plug-and-Play Hardware
          </h2>
          <p className="text-xl text-slate-400" data-id="element-40">
            A unified hardware layer that simplifies your entire installation
            workflow.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-41">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + idx * 0.1
        }} className="flex items-start gap-3 p-4 rounded-xl bg-slate-900 border border-slate-800" data-id="element-42">
              <div className="p-2 rounded-lg bg-slate-950 border border-slate-800" data-id="element-43">
                {feature.icon}
              </div>
              <div data-id="element-44">
                <h3 className="text-sm font-bold text-white mb-1" data-id="element-45">
                  {feature.title}
                </h3>
                <p className="text-slate-400 text-xs leading-relaxed" data-id="element-46">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      x: 50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="flex-1 flex justify-center items-center" data-id="element-47">
        <div className="relative max-w-lg" data-id="element-48">
          <div className="absolute inset-0 bg-blue-500/20 blur-3xl rounded-full" data-id="element-49" />
          <img src="https://cdn.magicpatterns.com/uploads/eLvXJSsZ9JqLfBo2tewicv/1000052439.png" alt="Plug-and-Play Hardware Device" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-50" />
        </div>
      </motion.div>
    </div>;
}